import axios from "axios";
import config  from '../../env.json';
import { useNavigate} from 'react-router-dom';

function createClientApi(payload:any,callback:any){
    try {
      axios({
        method: 'post',
        url:config.REACT_APP_ENV_API_BASE+'/client/clientcreate',
        data:payload
      })  
        .then(res=>{ 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
   
}

function getAllClients(payload:any,callback:any){
  try {
    axios({
      method: 'get',
      url:config.REACT_APP_ENV_API_BASE+'/clientenv/getclientenvbyempid',
      params:{'Emp_Id':payload}
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
}
function getAllEnvConfigVal(payload:any,callback:any){

  try {
    axios({
      method: 'get',
      url:config.REACT_APP_ENV_API_BASE+'/clientenv/getallenvconfigval',
      params:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null);
      })
  } catch (error) {
      callback(null)
  }
}
function getAllKeyvaultEnvConfigVal(payload:any,callback:any){

  try {
    axios({
      method: 'get',
      url:config.REACT_APP_ENV_API_BASE+'/clientenv/getkeyvaultvalues',
      params:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null);
      })
  } catch (error) {
      callback(null)
  }
}

function getAllNotificationStatusDetail(payload:any,callback:any){

  try {
    axios({
      method: 'get',
      url:config.REACT_APP_ENV_API_BASE+'/statussocket',
      params:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null);
      })
  } catch (error) {
      callback(null)
  }
}

function getAllEnvCategories(payload:any,callback:any){

  try {
    axios({
      method: 'get',
      url:config.REACT_APP_ENV_API_BASE+'/clientenv/getallenvconfigcategory',
      params:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null);
      })
  } catch (error) {
      callback(null)
  }
 
}
function createEnvApi(payload:any,callback:any){
    try {
      axios({
        method: 'post',
        url:config.REACT_APP_ENV_API_BASE+'/clientenv/clientenvcreate',
        data:payload
      })  
        .then(res=>{ 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
   
}

function updateConfigVal(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/clientenv/updateconfigval',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function addConfigVal(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/clientenv/addconfigval',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function addKeyvaultVal(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/clientenv/addkeyvaultvalue',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
}
function updateKeyvaultVal(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/clientenv/updatekeyvaultvalue',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
}
function deleteKeyvaultVal(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/clientenv/deletekeyvaultvalue',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}

function getEnvComparisonList (payload: any, callback: any) {
  try {
    axios({
      method: 'get',
      url:config.REACT_APP_ENV_API_BASE+`/clientenv/getcomparedkeyvaultvalues?FirstClient_Id=${payload.FirstClient_Id}&FirstEnv_Name=${payload.FirstEnv_Name}&FirstEnv_Id=${payload.FirstEnv_Id}&SecondClient_Id=${payload.SecondClient_Id}&SecondEnv_Name=${payload.SecondEnv_Name}&SecondEnv_Id=${payload.SecondEnv_Id}`,
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
}

async function migrateEnv(payload: any, callback: any) {
  try {
    await axios({
      method: "post",
      url: config.REACT_APP_ENV_API_BASE + "/clientenv/bulkAddkeyvaultvalue",
      data: payload,
    })
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        throw new Error('Could not migrate key values')
      });
  } catch (error) {
    throw new Error('Could not migrate key values')
  }
}
 

export {createClientApi,createEnvApi,getAllClients,updateConfigVal,getAllEnvConfigVal,addConfigVal,updateKeyvaultVal,getAllEnvCategories,deleteKeyvaultVal,getAllKeyvaultEnvConfigVal,addKeyvaultVal,getAllNotificationStatusDetail, getEnvComparisonList, migrateEnv}